module.exports = __webpack_public_path__ + "img/vantagen.5c52df3e.svg";